import {
  save,
  saveNew,
  saveSupport,
  destroy,
  replace,
  getToken,
  getRefreshToken,
  getUserId,
  getUserRole,
  isAdmin,
  getValue,
  getSecValue,
  isSupportSession,
  isExternalSession,
  getTokenAuth,
  setTokenAuth,
  setBackToken,
  isApiLogin
} from './_session'

export default {
  save,
  saveNew,
  saveSupport,
  destroy,
  replace,
  getToken,
  getRefreshToken,
  getUserId,
  getUserRole,
  isAdmin,
  getValue,
  getSecValue,
  isSupportSession,
  isExternalSession,
  getTokenAuth,
  setTokenAuth,
  setBackToken,
  isApiLogin
}
